//Core
import React from "react"

//Components
// import ListWithBullet from "./ListWithBullet"
import Card from "./Card"

//Images
import image2 from "../../images/2.png"
import image1 from "../../images/1.png"

//styles
import style from "./style.module.scss"
import Bounce from "react-reveal/Bounce"

const Cards = () => {
  return (
    <section className={style.CardsWrapper}>
      <Bounce top>
        <h2 className={style.title}>Максимальний дохід</h2>
      </Bounce>
      <Bounce top>
        <h3 className={style.subtitle}>
          <b className={style.number}>при розміщенні депозиту строком від 6 місяців</b>
        </h3>
      </Bounce>

      <div className={style.Cards}>
        <Bounce left>
          <Card
            image={image1}
            subtitle={"Хто  може взяти участь?"}
            cor={{ marginBottom: "32px" }}
            advantages={[
              `Всі клієнти, які відкриють депозит в ТАСКОМБАНК у лютому 2021 року!`,
            ]}
          />
        </Bounce>
        <Bounce right>
          <Card
            image={image2}
            subtitle={"Як взяти участь?"}
            advantages={[
              `Відкрити у будь-якому відділенні ТАСКОМБАНК депозит “Стабільний” у гривні строком від 6 місяців.`,
            ]}
          />
        </Bounce>
      </div>
    </section>
  )
}

export default Cards
